import React from "react";
import { useSpendingDemandPaymentSummary } from "../../../../hooks";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";

interface AcompteRendererProps {
  spendingDemandId: string;
}

export const AcompteRenderer: React.FC<AcompteRendererProps> = ({ spendingDemandId }) => {
  const { paymentSummary, isLoading } = useSpendingDemandPaymentSummary(spendingDemandId, {
    disableQuery: !spendingDemandId,
  });

  if (isLoading) {
    return <span style={{ color: "#999", fontSize: "0.8rem" }}>...</span>;
  }

  if (!paymentSummary.totalAcompte || paymentSummary.totalAcompte === 0) {
    return <span style={{ color: "#999" }}>-</span>;
  }

  return <span>{numberToStingWithSpaces(paymentSummary.totalAcompte)}</span>;
};

export default AcompteRenderer;
